import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface C1SubtitleProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function C1Subtitle({ children, className, ...props }: C1SubtitleProps) {
  return (
    <p className={cx('c1-subtitle', className)} {...props}>
      {children}
    </p>
  );
}
